import { iConfigColumn } from '../../../../shared/UITypes/types';

export const PAYMENTS_LIST_NAME = 'payment-list';
export const PAYMENTS_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Payment date',
    key: 'paymentDate',
    dataSource: [],
    isCompulsory: true,
    isSortable: true,
    type: 'date',
    isSelected: true,
    group: '',
  },
  {
    name: 'Amount',
    key: 'amount',
    dataSource: [],
    type: 'money',
    isSelected: true,
    group: '',
    isSortable: true,
  },
  {
    name: 'Payment method',
    key: 'method.name',
    dataSource: [],
    isSortable: false,
    isSelected: true,
    type: 'text',
    group: '',
  },
  {
    name: 'Comments',
    key: 'comments',
    dataSource: [],
    type: 'text',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Created',
    key: 'createdAt',
    dataSource: ['createdBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
  {
    name: 'Updated',
    key: 'updatedAt',
    dataSource: ['updatedBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
];
